import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getDetails, getUserDetails } from '../../../reducers/AdminUserMgtReducer';
import CustomTable from '../TableComponents/CustomTable';

const UserTable = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUserDetails());
  }, []);

  const userDetails = useSelector(getDetails);

  const UserColumns = [
    { id: 'user_id', label: 'User Id' },
    { id: 'name', label: 'User name' },
    { id: 'organization', label: 'Organization' },
    { id: 'role', label: 'Role' },
    { id: 'last_login', label: 'Recent Login' },
    { id: 'user_actions', label: 'Actions' },
  ];
  return (
    <>
      <CustomTable
        unique="user_id"
        columns={UserColumns}
        tableDetails={userDetails}
      />
    </>
  );
};
export default UserTable;
